import { Component, OnInit, HostListener, signal, ChangeDetectionStrategy, Inject, Renderer2, ChangeDetectorRef, NgZone } from '@angular/core';
import { ThemeService } from './core/services/theme/theme.service';
import { TranslateService } from "@ngx-translate/core";
import { environment } from '../environments/environment';
import { AuthService } from './core/services/auth/auth.service';
import { CacheService } from './shared/services/cache/cache.service';
import { SELECTED_LANGUAGE_KEY } from './types/constants';
import { ChatbotDisplayType } from './types/chatbot.model';
import { DOCUMENT } from '@angular/common';
import { LoginService } from './features/login/login.service';
import { HappiService } from './shared/services/happi/happi.service';

declare var $: any;
declare const OneTrust: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class AppComponent implements OnInit {
  email: string ;

  onFeedbackLoaded(isAvailable: boolean) {
    console.log('[Happi] loaded event received:', isAvailable);
    this.happiService.setHappiAvailability(isAvailable);
    this.cdr.detectChanges();
    this.ngZone.run(() => {
      console.log('[Happi] inside zone after load');
      this.happiService.setHappiAvailability(isAvailable);
      this.cdr.detectChanges();
    });
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private themeService: ThemeService,
    private translate: TranslateService,
    private authService: AuthService,
    private cacheService: CacheService,
    private loginService: LoginService,
    private happiService: HappiService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone) {

    this.translate.addLangs(['fr', 'en']);
    this.translate.setDefaultLang('en');
    let lang = this.cacheService.getItem(SELECTED_LANGUAGE_KEY);
    
    if(typeof lang !== 'string' || !this.translate.getLangs().includes(lang.toLowerCase())) {
      const browserLang = this.translate.getBrowserLang()?.toLowerCase();
      lang = browserLang === 'fr' ? 'fr' : 'en';
    }

    this.translate.use(lang.toLowerCase());
  }

  ngOnInit() {
    this.themeService.setThemeMode('light');
    this.loadScript();
    this.translate.onLangChange.subscribe((event: any) => {
        this.renderer.setAttribute(this.document.documentElement, 'lang', event.lang === 'fr' ? 'fr-FR' : 'en-GB');
        if(typeof OneTrust !== 'undefined' && typeof OneTrust.changeLanguage === 'function') {
          OneTrust.changeLanguage(event.lang === 'fr' ? 'fr-FR' : 'en-GB');
        }
    });

    this.loginService.getGigyaResp().userMail && (this.email = this.loginService.getGigyaResp().userMail);
    this.authService.gigyaUser$.subscribe(user => {
      if(user && user.userMail) {
        this.email = user.userMail;
      }
      else {
        if(!environment.production) {
          console.log("email not found");
        }
        if(this.email == '') {
          this.email = 'ASOS';
        }
      }
    });
    
  }

  // Triggers when user reloads or closes the tab
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    // if(this.isAuthenticated()) {
    //   this.authService.logout();
    // }
  }

  onHideFeedback() {
    console.log("Feedback hidden");
    this.happiService.setHappiAvailability(false);
    this.cdr.detectChanges();
    this.ngZone.run(() => {
      this.happiService.setHappiAvailability(false);
      this.cdr.detectChanges();
    });
  }

  protected position = signal<ChatbotDisplayType>('collapsible');
  protected isCollapsibleChatbotOpen = signal<boolean>(false);

  setDisplayPosition(position: ChatbotDisplayType) {
    this.position.set(position);
  }

  public loadScript() {
    let body = <HTMLHeadElement>document.head;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.type = 'text/javascript';
    script.lang = 'javascript';
    script.src = 'https://cdns.eu1.gigya.com/js/gigya.js?apikey=' + environment.api_key;
    script.async = true;
    script.onload = function() { }
    body.appendChild(script);
  }

  isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

}